import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import QAWidget from "./QAWidget";

export default function Layout({ children }) {
    const { pathname } = useLocation();

    // Scroll to top on route change
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
    }, [pathname]);

    return (
        <div className="hds-grain min-h-screen flex flex-col bg-[var(--hds-sand)]">
            <Header />
            <main className="flex-1 pt-[76px]">{children}</main>
            <Footer />
            <QAWidget />
        </div>
    );
}
